import React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import classNames from 'classnames';

import checkIco from '../../../assets/imgs/check.png';

const Container = styled.label.attrs({
  className: 'flex items-center mt-3',
})`
  &:first-child {
    margin-top: 0;
  }

  .form-checkbox:checked {
    ${tw`bg-primary`}
  }
  img {
    margin-left: 3px;
    margin-top: -2px;
  }

  div {
    min-width: 20px;
  }

  span {
    white-space: nowrap;
  }
`;

const Checkbox = ({ checked, label, onClick }) => (
  <Container onClick={onClick}>
    <div
      className={classNames(
        'min-w-[20px] w-5 h-5 border-2 border-solid border-black',
        checked && 'bg-light-yellow'
      )}
    >
      {checked && <img src={checkIco} alt="check-icon" />}
    </div>
    <span className="ml-2 text-black whitespace-nowrap">{label}</span>
  </Container>
);

export default Checkbox;
